import React, {useState} from 'react';
import { Button, Radio, type RadioChangeEvent } from 'antd';
import FilterModal from './FilterModal';

interface FilterOptionsProps {
  placement: string;
  placementChange: (e: RadioChangeEvent) => void;
  handleOk: (filters:any) => void;
  setCalculationFilters: (filter: any) => void;
  calculationFilters: any;
  filters: any;
}

const FilterOptions: React.FC<FilterOptionsProps> = ({
  placement,
  placementChange,
  handleOk,
  setCalculationFilters,
  calculationFilters,
  filters
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const closeAndHandleOk = (filters:any) => {
    setIsModalVisible(false);
    handleOk(filters);
  }
  const showModal = () => {
    setIsModalVisible(true);
  };
  return (
    <div style={{ display: 'flex', marginBottom: 14, marginTop: 30 }}>
      <div style={{ width: '23%' }}>
        <Button onClick={showModal} style={{ marginRight: '4%' }}>
          Filter
        </Button>
      </div>
      <div style={{ width: '54%', textAlign: 'center' }}>
        <Radio.Group
          value={placement}
          onChange={placementChange}
          style={{ marginLeft: 'auto' }}
        >
          <Radio.Button value="flight">By Flight</Radio.Button>
          <Radio.Button value="airport">By Airport</Radio.Button>
          <Radio.Button value="destinationCity">
            By Destination-City
          </Radio.Button>
          <Radio.Button value="destinationCountry">
            By Destination-Country
          </Radio.Button>
        </Radio.Group>
      </div>
      <div style={{ width: '23%', textAlign: 'right' }}>
        <Radio.Group defaultValue={1}>
          <Radio value={1}>One way</Radio>
          <Radio value={2}>Round trip</Radio>
        </Radio.Group>
      </div>
      <FilterModal
        isModalVisible={isModalVisible}
        handleOk={closeAndHandleOk}
        handleCancel={handleCancel}
        setCalculationFilters={setCalculationFilters}
        calculationFilters={calculationFilters}
        filterz={filters}
      />
    </div>
  );
};

export default FilterOptions;
